import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { scrolleZu } from "@/lib/scroll";

export default function GoldButton({
  children,
  href = "#",
  variant = "solid",
  testId,
  type,
  onClick,
  disabled,
  className = "",
}) {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 200, damping: 15 });
  const sy = useSpring(my, { stiffness: 200, damping: 15 });

  const handleMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    mx.set((e.clientX - r.left - r.width / 2) * 0.16);
    my.set((e.clientY - r.top - r.height / 2) * 0.28);
  };
  const reset = () => {
    mx.set(0);
    my.set(0);
  };
  const handleClick = (e) => {
    if (!type && href.startsWith("#")) {
      e.preventDefault();
      scrolleZu(href, { duration: 1.8 });
    }
    onClick?.(e);
  };

  const base =
    "group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full px-8 py-4 text-base font-medium tracking-wide transition-[box-shadow,border-color,color] duration-500 disabled:opacity-50 ";
  const styles =
    variant === "solid"
      ? "bg-gradient-to-br from-[#FFE9A8] via-[#D4AF37] to-[#8a6a1f] text-black shadow-[0_0_36px_rgba(212,175,55,0.25)] hover:shadow-[0_0_54px_rgba(212,175,55,0.45)]"
      : "border border-[#D4AF37]/40 text-[#F5F5F0] hover:border-[#D4AF37] hover:text-[#FFE9A8]";

  const inner = (
    <>
      <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 ease-out group-hover:translate-x-full" />
      <span className="relative">{children}</span>
    </>
  );

  return (
    <motion.div style={{ x: sx, y: sy }} className="inline-block">
      {type ? (
        <button
          ref={ref}
          type={type}
          disabled={disabled}
          onClick={handleClick}
          onMouseMove={handleMove}
          onMouseLeave={reset}
          data-testid={testId}
          data-cursor
          className={base + styles + " " + className}
        >
          {inner}
        </button>
      ) : (
        <a
          ref={ref}
          href={href}
          onClick={handleClick}
          onMouseMove={handleMove}
          onMouseLeave={reset}
          data-testid={testId}
          data-cursor
          className={base + styles + " " + className}
        >
          {inner}
        </a>
      )}
    </motion.div>
  );
}
